import { RMA } from '@one/types'
import { Module } from 'vuex'
import { mutations } from './mutations'
import { actions } from './actions'
import getters from './getters'
import { RMAState } from './types'
import App = RMA.App
import { RootState } from '~/store'
export const state = (): RMAState => ({
  createComplaint: {} as App.Request.ComplaintFormDto,
  complaintReasons: {},
  complaintDemands: {},
  complaintsList: {
    pageNumber: 1,
    pageSize: 30,
    totalItems: 0,
    totalPages: 0,
    items: {},
  } as RMA.App.Response.PagerComplaintDto,
  complaints: {},
  showComplaintStatus: true,
  isCreationFromGoodIssuedNotesEnabled: false,
})

const namespaced: boolean = true

const rma: Module<RMAState, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
  getters,
}

export default rma
